import React from "react";

import { FormControlLabel, Radio, RadioGroup } from "@mui/material";

const MEETS = "MEETS";
const DOEST_NOT_MEET = "DOES_NOT_MEET";

const getGenderAgeMeetCCValue = (row) => {
  const ageSplit = row.RuleFacts?.DisplayAgeRange?.split(/[,]/);
  if (
    row.RuleFacts?.DisplayAgeGenderRule === null ||
    row.RuleFacts?.DisplayAgeGenderRule === "" ||
    ageSplit === null ||
    (ageSplit?.length < 2 &&
      row.RuleFacts?.InvalidAgeRange !== null &&
      row.RuleFacts?.InvalidAgeRange !== "")
  ) {
    return DOEST_NOT_MEET;
  }
  return row.RuleFacts?.DisplayAgeGenderRule || "";
};
const GenderAgeMeetCC = ({
  updateRulesAfterEdit,
  editable,
  params,
  direction = "horizontal",
}) => {
  const GenderAgeMeetCCValue = getGenderAgeMeetCCValue(params.row);
  const handleGenderAgeMeetCC = (event) => {
    let newRow = structuredClone(params.row);
    newRow.RuleFacts.DisplayAgeGenderRule = event.target.value;
    updateRulesAfterEdit(newRow, params.row);
  };

  return (
    <RadioGroup
      row={direction === "horizontal"}
      value={GenderAgeMeetCCValue}
      onChange={handleGenderAgeMeetCC}
      name={"GenderAgeMeetCC-radios_" + params.id}
      sx={{
        "& .MuiFormControlLabel-root": {
          margin: direction === "horizontal" ? "0 8px 0 0" : "0 !important",
          padding: "0 !important",
          minHeight: "20px !important",
        },
        "& .MuiFormControlLabel-label": {
          marginLeft: "5px",
          fontSize: "0.8rem",
          lineHeight: "1",
          padding: 0,
        },
        "& .MuiRadio-root": {
          padding: 0,
          margin: 0,
        },
        padding: 0,
        margin: 0,
      }}
    >
      <FormControlLabel
        value={MEETS}
        disabled={!editable}
        control={<Radio />}
        label="Meets"
        labelPlacement="end"
      />
      <FormControlLabel
        value={DOEST_NOT_MEET}
        disabled={!editable}
        control={<Radio />}
        label="Does Not Meet"
        labelPlacement="end"
      />
    </RadioGroup>
  );
};

export default GenderAgeMeetCC;
